export default function () {
  return {
    prevRoute: {},
    currentRoute: {},
    authType: null,
    breadcrumbs: [],
    breadcrumbParams: {}
  }
}
